<template>
  <div class="blocked_logs_page">
    <h1>Live主播数据</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="isPay"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isPays"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

    </div>
    <div class="user-options clearfix">
      <el-input style="width:150px" type="text" v-model="host_id" placeholder="主播id"></el-input>
      <el-input style="width:150px" v-model="agent_id" type="text" placeholder="代理id"></el-input>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-table
        :data="tableList"
        style="width: 100%"
        border
        v-loading="login1"
      >
        <el-table-column align="center" fixed prop="date" label="日期" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="hostId" label="主播ID" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="hostName" label="主播昵称" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="agentId" label="代理ID" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="liveCount" label="开播次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="liveMin" label="开播时长(min)" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveUsers" label="进入Live人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveCount" label="进入Live次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payCount" label="付费次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payUsers" label="付费人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payMoney" label="付费金额"  sortable width="140">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgUsers" label="发言人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgCount" label="发言次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftUsers" label="送礼人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCount" label="送礼次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCost" label="送礼总消耗"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callUsers" label="拨打通话人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessUser" label="成功接听人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCount" label="拨打通话次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessCount" label="成功接听次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCost" label="扣费金额"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callTimes" label="通话时长"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="remainRoomTime" label="房间停留总时长"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="remainRoomAvgTime" label="人均停留时长"  sortable width="150">
        </el-table-column>
        <el-table-column align="center"  label="操作"  sortable width="150">
          <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="primary" size="small">查看</el-button>
      </template>
        </el-table-column>
      </el-table>
      <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="10"
      ></el-pagination>
    </el-row>

<el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="60%"
  :before-close="handleClose">
  <div >
        <div class="user-options clearfix">
          <span>主播：</span>
          <span class="fidet">{{hostId}}</span>
          <span>代理：</span>
          <span>{{agentId}}</span>
          <el-button type="primary" :loading="login2"  @click="get_list_" >查询</el-button>
        <el-button type="primary" @click="dwnDayChatDetai_">下载</el-button>
        </div>
        <div class="user-options clearfix">
          
      <el-select
        style="width: 160px"
        v-model="curChannel_.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels_"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language_"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList_"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country_"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList_"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType_"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes_"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="isPay_"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isPays_"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        </div>
     
     <el-table
        :data="tableList_"
        style="width: 100%"
        height="60vh"
        v-loading="login2"
        border
      >
        <el-table-column align="center"  prop="startTime" label="开播开始时间" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="endTime" label="开播结束时间" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="liveMin" label="开播时长(min)" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveUsers" label="进入Live人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveCount" label="进入Live次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payCount" label="付费次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payUsers" label="付费人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payMoney" label="付费金额"  sortable width="140">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgUsers" label="发言人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgCount" label="发言次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftUsers" label="送礼人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCount" label="送礼次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCost" label="送礼总消耗"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callUsers" label="拨打通话人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessUser" label="成功接听人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCount" label="拨打通话次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessCount" label="成功接听次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCost" label="扣费金额"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callTimes" label="通话时长"  sortable width="150">
        </el-table-column>
      </el-table>
      </div>
</el-dialog>
      
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      host_id: '',
      agent_id: '',
      hostId: '',
      agentId: '',
      login1: false,
      login2: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      curChannel_: {
        selectValue: 'total',
        content: ''
      },
      dialogVisible: false,
      channels: this.$store.state.channels,
      channels_: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      tableList_: [],
      loading: true,
      language: 'total',
      language_: 'total',
      languageList: '',
      languageList_: '',
      country: 'total',
      country_: 'total',
      countryList: '',
      countryList_: '',
      userType: 0,
      userTypes: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      isPay: 0,
      isPays: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '非付费用户',
          value: 1
        },
        {
          label: '付费用户',
          value: 2
        }
      ],
      isPay_: 0,
      isPays_: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '非付费用户',
          value: 1
        },
        {
          label: '付费用户',
          value: 2
        }
      ],
      userType_: 0,
      userTypes_: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.languageList_ = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
        this.countryList_ = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_liveHostStat,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType,
          hostId: this.host_id,
          isPay: this.isPay,
          page: this.page,
          agentId: this.agent_id
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_liveHostStat_xlsx,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType,
          isPay: this.isPay,
          hostId: this.host_id,
          agentId: this.agent_id
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, 'Live主播数据' + '')
    },
    // 下载
    async dwnDayChatDetai_() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_liveHostStatDetail_xlsx,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
        username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType,
          isPay: this.isPay,
          hostId: this.hostId,
          agentId: this.agentId
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, 'Live主播数据详情' + '')
    },
    handleClose(done) {
      done()
    },
    async handleClick(row) {
      this.dialogVisible = true
      this.country_ = this.country
      this.channel_ = this.channel
      this.userType_ = this.userType
      this.language_ = this.language
      this.hostId = row.hostId
      this.agentId = row.agentId
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_liveHostStatDetail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel_.selectValue,
          country: this.country_,
          language: this.language_,
          userType: this.userType_,
          hostId: this.hostId,
          isPay: this.isPay_,
          agentId: this.agentId
        }
      })
      this.tableList_ = res.data
    },
    async get_list_() {
      this.login2 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_liveHostStatDetail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel_.selectValue,
          country: this.country_,
          language: this.language_,
          userType: this.userType_,
          hostId: this.hostId,
          agentId: this.agentId
        }
      })
      this.login2 = false
      this.tableList_ = res.data
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
  .fidet {
     margin: 0 10px;
  }
}
</style>
